export const PATH_ROUTES = {
  home: '/',
  aiMeetings: '/meetingsAi',
  odCall: '/call',
  feedback: '/feedback',
  translations: '/translations',
  translationDetail: '/translations/:id',
  translationOrder: '/order-translation',
};